import '../css/main.scss';

import 'bootstrap';
